export type { PaperHeaderProps } from './paper-header';
export { default as PaperHeader } from './paper-header';
